import types from "../actionTypes";

export default (
  state = {
    maxSteps: 0,
    minSteps: 0,
    step: 1,
  },
  action
) => {
  switch (action.type) {
    case types.SET_COMPANY_CURRENT_STEP:
      return Object.assign({}, state, { step: action.step });
    case types.SET_COMPANY_MAX_STEPS:
      return Object.assign({}, state, { maxSteps: action.maxSteps });
    case types.SET_COMPANY_MIN_STEPS:
      return Object.assign({}, state, { minSteps: action.minSteps });
    case types.SET_COMPANY_ASSIGNED_LEVELS:
      return Object.assign({}, state, { companyAssignedLevels: action.companyAssignedLevels });
    case types.SET_COMPANY_LEVEL_ITEMS:
      return Object.assign({}, state, { companyLevelItems: action.companyLevelItems });
    default:
      return state;
  }
};
